export default __webpack_public_path__ + "static/media/theme-dark.5881971d.jpg";